import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import ButtonPrimary from "../../components/buttons/ButtonPrimary";
import InputPrimary from "../../components/input/InputPrimary";
import ItemCard from "./ItemCard";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Coupon from "./Coupon";
import { clearCart, setcoupon } from "../../redux/actions/checkout";
import { collection, doc, setDoc } from "firebase/firestore";
import { db } from "../../config/firebaseConfig";
import { HOSTNAME } from "../../config/constants";
import { v4 as uuidv4 } from "uuid";
import { setfeedback } from "../../redux/actions/feedback";
import { getCurrentDate, getCurrentTime } from "../../functions/time";

export default function Cart() {
  const dispatch = useDispatch();
  const { outlet, table } = useParams();

  const { cart, coupon } = useSelector((state) => state.checkout);
  const { activeOutlet } = useSelector((state) => state.config);

  const [couponPopup, setcouponPopup] = useState(false);

  function getTotalQuantity() {
    let total = 0;

    cart.forEach((el) => {
      total = total + el.qty;
    });

    return total;
  }

  function getTotalPrice() {
    let total = 0;

    cart.forEach((el) => {
      total = total + el.qty * el.price;
    });

    return total.toFixed(2);
  }

  function getCouponAmount() {
    if (coupon) {
      if (coupon.type === "percentage") {
        return ((getTotalPrice() * coupon.discount) / 100).toFixed(2);
      } else if (coupon.type === "value") {
        return (getTotalPrice() - coupon.discount).toFixed(2);
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  async function submitOrder() {
    try {
      dispatch(setfeedback({ loading: true, status: "", message: "Placing Order..." }));
      const menuDataRef = doc(db, "orders", HOSTNAME);
      const outletRef = doc(menuDataRef, "outlet", outlet);

      const orderId = uuidv4();
      const tableNo = table ? table : "takeaway";
      const ordersRef = doc(outletRef, "currentOrders", orderId);

      await setDoc(ordersRef, {
        orderId,
        tableNo,
        items: cart,
        status: "ordered",
        orderedAt: new Date(),
      });
      const getLocalOrders = localStorage.getItem("yourOrders");

      if (getLocalOrders) {
        const localOrders = JSON.parse(getLocalOrders);
        localStorage.setItem(
          "yourOrders",
          JSON.stringify({
            table: tableNo,
            orders: [...localOrders.orders, orderId],
          })
        );
      } else {
        localStorage.setItem(
          "yourOrders",
          JSON.stringify({
            table: tableNo,
            orders: [orderId],
          })
        );
      }

      dispatch(clearCart());
      dispatch(setfeedback({ loading: true, status: "s", message: "Order Placed Successfully!" }));

      setTimeout(() => {
        dispatch(setfeedback({ loading: false, status: "", message: "" }));
      }, 2000);
    } catch (error) {
      console.log(error);
    }
  }

  return cart.length > 0 ? (
    <div className="cart">
      <div className="left">
        <p className="bold uppercase grey mb-2">ITEMS IN CART</p>
        <div className="items-card-container">
          {cart.map((item) => (
            <ItemCard key={item.id} id={item.id} img={item.img} name={item.name} price={item.price} qty={item.qty} />
          ))}
        </div>
      </div>
      <div className="right">
        {/* <div className="coupon-card" onClick={() => setcouponPopup(true)}>
          <div className="flex-jb-ac">
            <h3 className="coupon-title">Apply Coupon</h3>
            <div className="icon">
              <ChevronRightIcon />
            </div>
          </div>

          {coupon && (
            <div className="flex-jb-ac mt-2">
              <p className="coupon-text">
                <span>{coupon.name}</span>applied successfully.
              </p>

              <p
                className="btn-remove"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setcoupon(null));
                }}
              >
                REMOVE
              </p>
            </div>
          )}
       
        </div> */}

        <div className="total-card">
          <h3 className="mb-2">Your Items</h3>
          <div className="header">
            <p className="name">NAME</p>
            <p className="qty">QTY</p>
            <p className="price">PRICE</p>
          </div>
          <div className="mb-2">
            {cart.map((item) => (
              <div key={item.id} className="content">
                <p className="name">{item.name}</p>
                <p className="qty">{item.qty}</p>
                <p className="price">
                  {activeOutlet.outletCurrency} {(item.price * item.qty).toFixed(2)}
                </p>
              </div>
            ))}
            {coupon && (
              <div className="content green">
                <p className="name">{coupon.name}</p>
                <p className="qty"></p>
                <p className="price minus">
                  {activeOutlet.outletCurrency} {getCouponAmount()}{" "}
                </p>
              </div>
            )}
          </div>
          {/* <div className="line" />
          <div className="total">
            <p className="total-text">TOTAL</p>
            <p className="qty">{getTotalQuantity()}</p>
            <p className="price">
              {activeOutlet.outletCurrency} {(getTotalPrice() - getCouponAmount()).toFixed(2)}
            </p>
          </div> */}

          <ButtonPrimary text="Place Order" onClick={submitOrder} />
        </div>
      </div>
      {/* <Coupon couponPopup={couponPopup} setcouponPopup={setcouponPopup} totalPrice={getTotalPrice()} /> */}
    </div>
  ) : (
    <div className="empty-cart">
      <p className="message">No items in cart 🍕</p>
      <Link to="/" className="btn">
        <p>Browse Menu</p>
      </Link>
    </div>
  );
}
